import { FaIcon } from '../../../../../design-system/icon/fa-icon';
import { Stack } from '../../../../../design-system/stack/stack';

type CategorySelectTriggerContentProps = {
  level1?: string;
  level2?: string;
  icon?: string;
};

export const CategorySelectTriggerContent = ({ level1, level2, icon }: CategorySelectTriggerContentProps) => {
  if (!level1 || !level2) {
    return null;
  }

  return (
    <div className="flex items-center">
      <FaIcon iconName={icon ?? ''} className="w-8 text-muted-foreground" />
      <Stack space={1} align="start" className="ml-3">
        <p className="text-sm font-thin text-black">{level2}</p>
        <p className="text-xs font-normal text-muted-foreground">Change category</p>
      </Stack>
    </div>
  );
};
